import { cyolistStore } from '../cyolist/cyolist';
export default {

    async addToCompare(data) {
        
        const listStore = cyolistStore()
        const isCompareListExeeded = listStore.getDiamondCompareListExeedStatus()

        if(isCompareListExeeded && !data.diamond.is_compared_count){
            return { 'status': 'alert', 'title':'Error', 'msg': 'Maximum 40 diamonds can be added to compare list.' }
        }

        const payload = data.diamond.is_compared_count ? { item_id: data.diamond.id, action: 'remove' } : { item_id: data.diamond.id, action: 'add' }

        let url = useCountryPath('/diamond/compare/add', true);

        if (data.moduleSubType === 'earring') {

            url = useCountryPath('/diamond/loose-pair/compare/add', true)
        }
        
        listStore.markAddOrRemoveFromCompare(payload)
       
        try {
            const response = await $fetch(url, {
                method: 'POST',
                body: payload
            })
            if (response) {


                if (response.data.is_exceeded === 1 && payload.action === 'add') {

                    listStore.commitMutation( 'setDiamondCompareListCount', response.data.count )
                    return { 'status': 'alert', 'title':'Error', 'msg': 'Maximum 40 diamonds can be added to compare list.' }
                }

                else if (payload.action === 'add') {

                    listStore.commitMutation( 'setDiamondCompareListCount', response.data.count )
                    return { 'status': 'success', 'title':'Success', 'msg': 'Diamond added to compare list.' }
                }

                else if (payload.action === 'remove') {

                    listStore.commitMutation( 'setDiamondCompareListCount', response.data.count )
                    return { 'status': 'success', 'title':'Success', 'msg': 'Diamond removed from compare list.' }
                }

            }

        }
        catch (error) {
            console.log(error, 'errors')
        }
    }

}